import React from "react";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { useImagePath } from "hooks";
import { Container, Text } from "./styles";

interface BannerProps {
	firstContributionText: string | undefined;
	firstContributionSubText: string | undefined;
	firstContributionRewardBonus: string | undefined;
	firstContributionRewardBonusSubText: string | undefined;
	firstContributionRewardBonusFinalText: string | undefined;
}

export const FirstContributionBanner: React.FC<BannerProps> = ({
	firstContributionText,
	firstContributionSubText,
	firstContributionRewardBonus,
	firstContributionRewardBonusSubText,
	firstContributionRewardBonusFinalText
}) => {
	const { getImage } = useImagePath("cdn");
	const backgroundImage = getImage(
		clubGiftsGaloreAssets.v2.giftBoxes.firstTimeBadge
	);

	return (
		<Container
			$backgroundImage={backgroundImage}
			style={{ paintOrder: "stroke fill" }}
		>
			<Text>
				<span className="first-contribution-text">{firstContributionText}</span>
				<span className="first-contribution-sub-text">
					{firstContributionSubText}
				</span>
				<span className="first-contribution-bonus">
					{firstContributionRewardBonus}
				</span>
				<span className="first-contribution-bonus-sub-text">
					{firstContributionRewardBonusSubText}
				</span>
				<span className="first-contribution-bonus-final-text">
					{firstContributionRewardBonusFinalText}
				</span>
			</Text>
		</Container>
	);
};
